import { ENV } from "../utils";
export class Deviation {
  baseApi = ENV.BASE_API;
  async getDeviations(accessToken, active = true) {
    const r = await fetch(`${this.baseApi}/deviations?active=${active}`, { headers: { Authorization: `Bearer ${accessToken}` } });
    const d = await r.json(); if (r.status !== 200) throw d; return d;
  }
  async createDeviation(accessToken, data) {
    const r = await fetch(`${this.baseApi}/add-deviation`, { method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` }, body: JSON.stringify(data) });
    const d = await r.json(); if (r.status !== 200) throw d; return d;
  }
  async updateDeviation(accessToken, id, data) {
    const r = await fetch(`${this.baseApi}/update-deviation/${id}`, { method: "PUT", headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` }, body: JSON.stringify(data) });
    const d = await r.json(); if (r.status !== 200) throw d; return d;
  }
  async deleteDeviation(accessToken, id) {
    const r = await fetch(`${this.baseApi}/delete-deviation/${id}`, { method: "DELETE", headers: { Authorization: `Bearer ${accessToken}` } });
    const d = await r.json(); if (r.status !== 200) throw d; return d;
  }
}
